import { DEFAULT_FONT_FAMILY } from 'common/constants';
import styled from 'styled-components';

interface IStyleProps {
  marginBottomValue?: string;
}

export const Root = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  min-height: 148px;
  border-radius: 5px;
  border: solid 1px rgba(189, 189, 189, 0.5);
  display: flex;
  position: relative;
`;

export const Metadata = styled.div`
  min-width: 82px;
  width: 82px;
  padding: 10px 18px;
`;

export const MetaName = styled.div`
  color: #2d3548;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const MetaLocation = styled.div`
  color: #2d3548;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const MetaUrl = styled.a`
  color: #4da0ff;
  text-decoration: none;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const MetaDate = styled.div`
  color: #2d3548;
  margin-top: 10px;
`;

export const Content = styled.div`
  margin-bottom: ${(props: IStyleProps) => (props.marginBottomValue ?? 'auto')};
`;

export const ContentStars = styled.div`
  display: flex;
  justify-content: start;
  margin-top: 10px;
  margin-bottom: 13px;
`

export const ContentTitle = styled.div`
  font-weight: 500;
  margin-left: 5px;
  margin-bottom: 10px;
`;

export const ContentDetail = styled.div`
  margin-left: 5px;
  margin-right: 18px;
  margin-bottom: 10px;
`;

export const ContentDate = styled.div`
  position: absolute;
  top: 10px;
  right: 18px;
  color: #2d3548;
`;

export const ContentFeatureContainer = styled.div`
  position: absolute;
  right: 19px;
  bottom: 5px;
`;



